import { useTranslation } from 'react-i18next'

import { InputWithLabel, Text } from '@reveni-io/reveni-ui'

import LocationTypeSelector from './LocationTypeSelector/LocationTypeSelector'
import * as Styles from './styles'

const TypeSection = ({ type, setType, internalName, setInternalName, publicName, setPublicName }) => {
  const { t } = useTranslation()

  const handleInternalNameChange = e => setInternalName(e.target.value)
  const handlePublicNameChange = e => setPublicName(e.target.value)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Tipo')}</Text>
      <LocationTypeSelector type={type} onChange={setType} />
      <InputWithLabel label={t('Nombre interno')} value={internalName} onChange={handleInternalNameChange} fullWidth />
      <InputWithLabel label={t('Nombre público')} value={publicName} onChange={handlePublicNameChange} fullWidth />
    </Styles.Container>
  )
}

export default TypeSection
